import React, { useState,useEffect } from "react";
import Layout from "../../components/Layout";
import "./FaqPage.scss";
import AboutUs from "../AboutUs/AboutUs";

function FaqPage() {

  const [activeIndexGeneral, setActiveIndexGeneral] = useState(null);
  const [activeIndexTreatment, setActiveIndexTreatment] = useState(null);
  const [activeIndexPayment, setActiveIndexPayment] = useState(null);
  const [activeIndexPractical, setActiveIndexPractical] = useState(null);
  const [activeIndexPelvic, setActiveIndexPelvic] = useState(null);

  const toggleQuestion = (index, setActiveIndex, currentIndex) => {
    setActiveIndex(currentIndex === index ? null : index);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  },[]);

  const faqData1 = [
    {
      id: 1,
      question: "What is physiotherapy, and how can it help me?",
      answer: "Physiotherapy focuses on improving mobility, relieving pain, and restoring function through personalized treatments and exercises. It can help with injuries, chronic conditions, and post-surgery recovery.",
    },
    {
      id: 2,
      question: "Do I need a doctor’s referral to book an appointment?",
      answer: "In most cases, you don’t need a referral to see a physiotherapist. However, some insurance providers may require one for coverage.",
    },
    {
      id: 3,
      question: "What should I expect during my first visit?",
      answer: "During your first visit, we will assess your condition, discuss your goals, and create a personalized treatment plan. Wear comfortable clothing for easy movement.",
    },
    {
      id: 4,
      question: "How many sessions will I need?",
      answer: "The number of sessions depends on your condition, treatment goals, and progress. Your physiotherapist will discuss a plan with you during your assessment.",
    }
  ];
  const faqData2 = [
    {
      id: 1,
      question: "What treatment methods do you use?",
      answer: "We offer a variety of evidence-based treatments, including manual therapy, therapeutic exercises, electrotherapy, dry needling, and more.",
    },
    {
      id: 2,
      question: "Do you provide home exercises?",
      answer: "Yes, we provide personalized home exercise plans to support your recovery and ensure long-term progress.",
    },
    {
      id: 3,
      question: "Do you offer specialized programs?",
      answer: "Yes, we provide tailored programs such as sports rehabilitation, postural correction, and chronic pain management.",
    },
    {
      id: 4,
      question: "Can physiotherapy help with posture improvement?",
      answer: "Absolutely! Our therapists can assess your posture and provide exercises and techniques to improve alignment and reduce strain.",
    }
  ];
  const faqData3 = [
    {
      id: 1,
      question: "Do you accept insurance?",
      answer: "Physiotherapy focuses on improving mobility, relieving pain, and restoring function through personalized treatments and exercises. It can help with injuries, chronic conditions, and post-surgery recovery.",
    },
    {
      id: 2,
      question: "What are your payment options?",
      answer: "We accept cash, debit, credit cards, and direct insurance billing where applicable.",
    },
    {
      id: 3,
      question: "Is physiotherapy covered under my insurance plan?",
      answer: "Coverage varies by provider. Contact your insurance company to check if physiotherapy is included and if a referral is required.",
    }
  ];
  const faqData4 = [
    {
      id: 1,
      question: "How do I book an appointment?",
      answer: "You can book an appointment online through our website, call us directly, or visit our clinic in person.",
    },
    {
      id: 2,
      question: "What should I wear to my appointment?",
      answer: "Wear loose, comfortable clothing that allows easy movement. For example, shorts for lower body issues or tank tops for shoulder concerns.",
    },
    {
      id: 3,
      question: "What is your cancellation policy?",
      answer: "We require [insert hours, e.g., 24 hours] notice for cancellations to avoid a cancellation fee.",
    },
    {
      id: 4,
      question: "Do you offer weekend or evening appointments?",
      answer: "Yes, we offer flexible scheduling options, including evening and weekend appointments, to accommodate your needs.",
    }
  ];
  const faqData5 = [
    {
      id: 1,
      question: "What is pelvic health physiotherapy?",
      answer: "Pelvic health physiotherapy focuses on diagnosing and treating conditions related to the pelvic floor muscles, which play a vital role in bladder control, bowel function, sexual health, and core stability.",
    },
    {
      id: 2,
      question: "Do you offer prenatal and postpartum physiotherapy?",
      answer: "Yes, we provide specialized care for prenatal and postpartum clients to manage pregnancy-related pain, prepare for labor, and recover after childbirth.",
    },
    {
      id: 3,
      question: "What happens during a pelvic health assessment?",
      answer: "A pelvic health assessment includes a detailed discussion of your symptoms, a physical assessment of posture and core muscles, and, if necessary, an internal exam to evaluate the strength and function of your pelvic floor muscles.",
    },
    {
      id: 4,
      question: "Is the internal exam mandatory for pelvic physiotherapy?",
      answer: "No, the internal exam is optional. It is a highly effective way to assess pelvic floor health, but your comfort and consent are our top priorities.",
    },
    {
      id: 5,
      question: "How does physiotherapy help with urinary incontinence?",
      answer: "Physiotherapy strengthens the pelvic floor muscles, retrains bladder habits, and improves coordination, helping to manage or eliminate urinary incontinence",
    },
    {
      id: 6,
      question: "Can pelvic physiotherapy help with chronic pelvic pain?",
      answer: "Yes, pelvic physiotherapy can address chronic pelvic pain caused by muscle tension, nerve irritation, or other dysfunctions. Treatment includes manual therapy, stretches, and exercises to alleviate pain and improve function.",
    }
  ];

  return (
    <Layout>
      <div className="faq-container">
        <h1 className="faq-title">General Questions</h1>
        <div className="faq-list">
          {faqData1.map((item, index) => (
            <div key={index} className="faq-item">
              <button
                className={`faq-question ${activeIndexGeneral === index ? 'active' : ''}`}
                onClick={() => toggleQuestion(index, setActiveIndexGeneral, activeIndexGeneral)}
              >
                {item.question}
                <span className="faq-icon">{activeIndexGeneral === index ? '−' : '+'}</span>
              </button>
              {activeIndexGeneral === index && (
                <div className="faq-answer">{item.answer}</div>
              )}
            </div>
          ))}
        </div>
        <h1 className="faq-title">Treatment & Services</h1>
        <div className="faq-list">
          {faqData2.map((item, index) => (
            <div key={index} className="faq-item">
              <button
                className={`faq-question ${activeIndexTreatment === index ? 'active' : ''}`}
                onClick={() => toggleQuestion(index, setActiveIndexTreatment, activeIndexTreatment)}
              >
                {item.question}
                <span className="faq-icon">{activeIndexTreatment === index ? '−' : '+'}</span>
              </button>
              {activeIndexTreatment === index && (
                <div className="faq-answer">{item.answer}</div>
              )}
            </div>
          ))}
        </div>
        <h1 className="faq-title">Payment & Insurance</h1>
        <div className="faq-list">
          {faqData3.map((item, index) => (
            <div key={index} className="faq-item">
              <button
                className={`faq-question ${activeIndexPayment === index ? 'active' : ''}`}
                onClick={() => toggleQuestion(index, setActiveIndexPayment, activeIndexPayment)}
              >
                {item.question}
                <span className="faq-icon">{activeIndexPayment === index ? '−' : '+'}</span>
              </button>
              {activeIndexPayment === index && (
                <div className="faq-answer">{item.answer}</div>
              )}
            </div>
          ))}
        </div>
        <h1 className="faq-title">Practical Questions</h1>
        <div className="faq-list">
          {faqData4.map((item, index) => (
            <div key={index} className="faq-item">
              <button
                className={`faq-question ${activeIndexPractical === index ? 'active' : ''}`}
                onClick={() => toggleQuestion(index, setActiveIndexPractical, activeIndexPractical)}
              >
                {item.question}
                <span className="faq-icon">{activeIndexPractical === index ? '−' : '+'}</span>
              </button>
              {activeIndexPractical === index && (
                <div className="faq-answer">{item.answer}</div>
              )}
            </div>
          ))}
        </div>
        <h1 className="faq-title">Pelvic Health Physiotherapy</h1>
        <div className="faq-list">
          {faqData5.map((item, index) => (
            <div key={index} className="faq-item">
              <button
                className={`faq-question ${activeIndexPelvic === index ? 'active' : ''}`}
                onClick={() => toggleQuestion(index, setActiveIndexPelvic, activeIndexPelvic)}
              >
                {item.question}
                <span className="faq-icon">{activeIndexPelvic === index ? '−' : '+'}</span>
              </button>
              {activeIndexPelvic === index && (
                <div className="faq-answer">{item.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>
      <AboutUs />
    </Layout>
  );
}

export default FaqPage;